<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	export default {
		props: {
			//用于判断新增0 查看1 编辑2
			isOpenType: '',
			jbxxdiag: false,
			jbrxxList: [],
			naturalDirect: getdata().formdata,
			digitalRpaInfo: {
				default: {},
				type: Object
			}
		},
		data() {
			return {
				formlist: getdata().formlist,
				formdata: getdata().formdata,
				//经办人信息
				HandlerInformationData: [{
					isBianj: true,
					xingm: '',
					guoj: '',
					zhengjlx: '',
					zhengjhm: '',
					zirrnsrsbh: '',
					shifmr: '0'
				}],
				//国籍
				options: getdata().options,
				//证件类型
				zhengjlx: getdata().zhengjlx,

				//数电发票开票方式：1：乐企通道 2:RPA
				shudfpkpfs: "1",

				rpaFormList: getdata().rpaFormList,
				rpaformdata: getdata().rpaformdata,
				initRpaFormList: getdata().rpaFormList,
				//二维码接收方式
				qrReceiveWay: [],
				//手机号
				phone: "",
				//邮箱
				email: "",

				rpaWay: "",
				rpaSelectOptions: [{
						value: '1',
						label: 'RPA-M'
					},
					{
						value: '2',
						label: 'RPA-P'
					}
				],
			};
		},
		watch: {
			'rpaformdata.loginWay'(newVal, oldVal) {
				this.loginWayChange(newVal)
			},
			// shudfpkpfs(newVal, oldVal) {
			// 	if (newVal == "1") {
			// 		this.formlist = JSON.parse(JSON.stringify(getdata().formlist));
			// 		this.formlist.forEach(v => {
			// 			v.disabled = false;
			// 		});
			// 	}else{
			// 		this.formlist = JSON.parse(JSON.stringify(getdata().formlist));
			// 		this.formlist.forEach(v => {
			// 			v.disabled = true;
			// 		});
			// 	}
			// }
		},
		created() {
			if (this.digitalRpaInfo != null) {
				if (this.digitalRpaInfo.qrReceiveWay != "" && this.digitalRpaInfo.qrReceiveWay != null) {
					this.qrReceiveWay = this.digitalRpaInfo.qrReceiveWay.split(",")
				} else {
					this.qrReceiveWay = []
				}
				this.phone = this.digitalRpaInfo.phone;
				this.email = this.digitalRpaInfo.email;
				this.rpaWay = this.digitalRpaInfo.rpaWay;
				this.shudfpkpfs = this.digitalRpaInfo.shudfpkpfs;
				this.rpaformdata.loginAccount = this.digitalRpaInfo.loginAccount;
				this.rpaformdata.loginPassword = this.digitalRpaInfo.loginPassword;
				this.rpaformdata.loginIdentities = this.digitalRpaInfo.loginIdentities;
				this.rpaformdata.loginWay = this.digitalRpaInfo.loginWay;
				this.rpaformdata.diskNo = this.digitalRpaInfo.diskNo;
				this.rpaformdata.clientId = this.digitalRpaInfo.clientId;
				this.rpaformdata.clientSecret = this.digitalRpaInfo.clientSecret;
				this.shudfpkpfsChange(this.digitalRpaInfo.rpaWay)
			}
		},
		mounted() {


		},
		methods: {
			Chushua() {
				
				if (this.digitalRpaInfo != null) {
					if (this.digitalRpaInfo.qrReceiveWay != "" && this.digitalRpaInfo.qrReceiveWay != null) {
						this.qrReceiveWay = this.digitalRpaInfo.qrReceiveWay.split(",")
					} else {
						this.qrReceiveWay = []
					}
					this.phone = this.digitalRpaInfo.phone;
					this.email = this.digitalRpaInfo.email;
					this.rpaWay = this.digitalRpaInfo.rpaWay;
					this.shudfpkpfs = this.digitalRpaInfo.shudfpkpfs;
					this.rpaformdata.loginAccount = this.digitalRpaInfo.loginAccount;
					this.rpaformdata.loginPassword = this.digitalRpaInfo.loginPassword;
					this.rpaformdata.loginIdentities = this.digitalRpaInfo.loginIdentities;
					this.rpaformdata.loginWay = this.digitalRpaInfo.loginWay;
					this.rpaformdata.diskNo = this.digitalRpaInfo.diskNo;
					this.rpaformdata.clientId = this.digitalRpaInfo.clientId;
					this.rpaformdata.clientSecret = this.digitalRpaInfo.clientSecret;
					this.shudfpkpfsChange(this.digitalRpaInfo.rpaWay)
				}
			},
			//清空
			QjangKaj() {
				this.rpaformdata = {
					loginAccount: "",
					loginPassword: "",
					loginIdentities: "",
					loginWay: "",
					diskNo: "",
					clientId: "",
					clientSecret: "",
				}
				this.phone = "";
				this.email = "";
				this.naturalDirect = {};
				this.shudfpkpfs = "1"
				this.rpaWay = ""
				this.qrReceiveWay = []
				this.$refs['reftaxform'].clearValidate()
			},
			//子主键方法
			ZHiZujian(isOpenType) {
				this.isOpenType = isOpenType;
				if (isOpenType == '0') {
					this.formlist = getdata().formlist;
					this.rpaFormList = getdata().rpaFormList;
					this.formdata = {
						accessUnitNaturalId: '',
						useCaseCoding: '',
						accessSignature: '',
						useUnitNaturalId: '',
						sandboxTestMark: ''
					};
					this.HandlerInformationData = [{
						isBianj: true,
						xingm: '',
						guoj: '',
						zhengjlx: '',
						zhengjhm: '',
						zirrnsrsbh: '',
						shifmr: '0'
					}];
				} else if (isOpenType == '1') {
					this.formlist = JSON.parse(JSON.stringify(getdata().formlist));
					this.formlist.forEach(v => {
						v.disabled = true;
					});
					this.rpaFormList = JSON.parse(JSON.stringify(getdata().rpaFormList));
					this.rpaFormList.forEach(v => {
						v.disabled = true;
					});
					this.formdata = JSON.parse(JSON.stringify(this.naturalDirect));
					this.HandlerInformationData = JSON.parse(
						JSON.stringify(
							this.jbrxxList.map(v => {
								v.isBianj = false;
								return v;
							})
						)
					);
				} else if (isOpenType == '2') {
					this.formlist = JSON.parse(JSON.stringify(getdata().formlist));
					this.rpaFormList = JSON.parse(JSON.stringify(getdata().rpaFormList));
					this.HandlerInformationData = [];
					this.formdata = {};
					this.formdata = JSON.parse(JSON.stringify(this.naturalDirect));
					this.HandlerInformationData = JSON.parse(
						JSON.stringify(
							this.jbrxxList.map(v => {
								v.isBianj = true;
								return v;
							})
						)
					);
				}
			},
			//是否默认值发生改变
			RadioLabel(index) {
				if (this.HandlerInformationData[index].shifmr == '1') {
					for (let i = 0; i < this.HandlerInformationData.length; i++) {
						if (index != i) {
							this.HandlerInformationData[i].shifmr = '0';
						}
					}
				}
			},
			//上添加
			TopAdd(index) {
				this.HandlerInformationData.splice(index == 0 ? 0 : index - 1, 0, {
					isBianj: true,
					xingm: '',
					guoj: '',
					zhengjlx: '',
					zhengjhm: '',
					zirrnsrsbh: '',
					shifmr: '0'
				});
			},
			//下添加
			bottomAdd(index) {
				this.HandlerInformationData.splice(index + 1, 0, {
					isBianj: true,
					xingm: '',
					guoj: '',
					zhengjlx: '',
					zhengjhm: '',
					zirrnsrsbh: '',
					shifmr: '0'
				});
			},
			//删除
			DeleteJbr(index) {
				if (this.HandlerInformationData.length > 1) {
					this.HandlerInformationData.splice(index, 1);
				}
			},
			//编辑
			compileda(index) {
				this.HandlerInformationData[index].isBianj = !this.HandlerInformationData[index].isBianj;
			},
			shudfpkpfsChange(value) {
				this.rpaFormList = this.initRpaFormList
				if(this.isOpenType == '1') {
					this.rpaFormList.forEach(item => {
						item.disabled = true;
					})
				} else {
					this.rpaFormList.forEach(item => {
						item.disabled = false;
					})
				}
				if (value == "1") {
					this.loginWayChange(this.rpaformdata.loginWay)

				}else if(value == "2"){
					//rpa-p 隐藏一些属性
					this.rpaFormList = JSON.parse(JSON.stringify(this.rpaFormList.filter(item => !['diskNo', 'loginIdentities', 'loginWay'].includes(item.prop))))
				}
				
				this.shudfpkpfsClick(this.shudfpkpfs)
			},
			loginWayChange(newVal) {
				if (newVal == "1") {
					this.rpaFormList.forEach(item => {
						if (item.prop == "diskNo") {
							item.disabled = false;
							item.isnotnull = true;
						}
					})
				} else {
					this.rpaFormList.forEach(item => {
						if (item.prop == "diskNo") {
							item.disabled = true;
							item.isnotnull = false;
							this.rpaformdata.spbh = "";
						}
					})
				}
			},
			shudfpkpfsClick(value) {
				if(value == "1") {
					this.rpaFormList.forEach(item => {
						item.isnotnull = false;
					})
				} else {
					this.rpaFormList.forEach(item => {
						if (item.prop == "loginAccount" || item.prop == "loginPassword" || item.prop == "clientId" || item.prop == "loginIdentities" || item.prop == "loginWay" || item.prop == "clientSecret") {
							item.isnotnull = true;
						}
					})
				}
				this.$refs.reftaxform.getnum()
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>